export default {
  style: 0,
  barcode_enabled: true
};